import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { MktEnvironmentService } from './mkt-environment.service';
import { CookieService } from '@citi-gcg-173875/citi-utils';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable()
export class MktSessionService {
  private isSessionActiveSubject = new BehaviorSubject<any>(null);
  pageTimer;

  _timeout;
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private _mktEnvironmentService: MktEnvironmentService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      // Fallback flag for legacy session handling
      // if (this._mktEnvironmentService.getEnvironmentVar('CBOL_SESSION_LEGACY_FALLBACK')) {
        // NGA CBOL session
        this.makeKeepAliveCall();
      // } else {
        // Legacy CBOL session
        // this.initializeService();
      // }
    }
  }

  initializeService() {
    this.includeSessionScriptInHead();
  }

  makeKeepAliveCall() {
    let authToken, bizToken, cookieArray;

    cookieArray = this.cookieService.getCookie('NGACoExistenceCookie');

    if (cookieArray.length != 0) {
      authToken = "Bearer " + cookieArray[0].split('=')[1];
      bizToken = cookieArray[1].split('=')[1];
      console.log('CBOL SESSION ------- using NGACoexistanceCookie');
    }
    else {
      authToken = "Bearer " + this.cookieService.getCookie('Authorization');
      bizToken = this.cookieService.getCookie('bizToken');
      console.log('CBOL SESSION ------- using auth/bizToken');
    }

    const headers = new HttpHeaders({
      authorization: authToken,
      biztoken: bizToken,
      businesscode: 'GCB',
      channelid: 'CBOL',
      accept: 'application/json',
			'accept-language': 'en_US',
			'client_id': '3ea31584-77fb-4b6d-bec2-65a45cae1664',
			'Content-Type': 'application/json',
      'countryCode' : 'US'
    });
    // console.log('CBOL SESSION ------- ', authToken, ', ', bizToken);

    const NGAEndpoint = this._mktEnvironmentService.getEnvironmentVar('CBOL_URL') + '/gcgapi/uat2/public/v1/public/sso/keepalive'

    this.http.post(NGAEndpoint, {}, { headers: headers, withCredentials: true }).toPromise().then((resp: HttpResponse<any>) => {
      console.log('CBOL SESSION ------- response - ', resp);
      const isCBOLSessionActive = resp.ok ? true : false;
      console.log('CBOL SESSION ------- isCBOLSessionActive - ', isCBOLSessionActive);
      this.sendIsSessionActive(isCBOLSessionActive);

      if (isCBOLSessionActive) {
        // Include this empty function to avoid errors when the CBOLServerAlive.do script loads and trys to call this javascript function
        window["sessionCheckReturn"] = function () { };
        this._timeout = document.getElementById("brandingData_federated_timeout").innerText;
        this.setPageTimeout();
      }
    });
  }



  //Includes a js script that provides session data based off the CUUID. Also grabs cookies from online.citi
  includeSessionScriptInHead() {
    let scriptElement = document.createElement('script');
    scriptElement.src = this._mktEnvironmentService.getEnvironmentVar('CBOL_URL') + "/US/JRS/misc/bridge.do?u=FS_CardsMkt|11111111";
    scriptElement.type = "text/javascript";
    scriptElement.nonce = "CSP_NONCE_PLACEHOLDER";
    document.getElementsByTagName("head")[0].appendChild(scriptElement);
    let thisReference = this;
    scriptElement.addEventListener('load', function () {
      window['citilm'].loadCitiBrand();

      const isCBOLSessionActive = window['isCBOLSessionNotActive'] === "N" ? true : false;
      thisReference.sendIsSessionActive(isCBOLSessionActive);

      if (isCBOLSessionActive) {
        // Include this empty function to avoid errors when the CBOLServerAlive.do script loads and trys to call this javascript function
        window["sessionCheckReturn"] = function () { };
        thisReference._timeout = document.getElementById("brandingData_federated_timeout").innerText;
        thisReference.setPageTimeout();
      }
    });
  }

  sendIsSessionActive(isSessionActive: boolean) {
    this.isSessionActiveSubject.next(isSessionActive);
  }
  getIsSessionActive(): Observable<any> {
    return this.isSessionActiveSubject.asObservable();
  }

  setPageTimeout() {
    let thisReference = this;
    if (typeof this._timeout !== "undefined" && this._timeout !== '') {
      const val = parseInt(this._timeout) + 25;
      this.pageTimer = setTimeout(function () {
        thisReference.callSessionCheck();
      }, (val * 1000));
    }
  }


  callSessionCheck() {
    let thisReference = this;
    let scriptElement = document.createElement('script');
    scriptElement.src = this._mktEnvironmentService.getEnvironmentVar('CBOL_URL') + "/JRS/misc/CBOLServerAlive.do";
    scriptElement.type = "text/javascript";
    scriptElement.id = "sessionTimeout";
    scriptElement.nonce = "CSP_NONCE_PLACEHOLDER";
    document.getElementsByTagName("body")[0].appendChild(scriptElement);
    scriptElement.addEventListener('load', function () {
      let isVisitorValue = window["isVisitorValue"] === "N" ? false : true;
      thisReference.sessionCheckReturn(isVisitorValue);
    });
  }

  sessionCheckReturn(isVisitorValue) {
    if (typeof isVisitorValue != 'undefined') {
      if (isVisitorValue === false) {
        this.setPageTimeout();
      } else {
        this.sessionRecovery();
      }
    }
  }

  sessionRecovery() {
    window.location.href = this._mktEnvironmentService.getEnvironmentVar('CBOL_URL') + '/JSO/signon/CBOLSessionRecovery.do';
  }
}
